import {z} from 'zod';

const paginatedSchema = <T extends z.ZodType<any>>(schema: T) => {
    return z.object({
        content: z.array(schema),
        page: z.object({
            size: z.number(),
            totalElements: z.number(),
            totalPages: z.number(),
            number: z.number()
        })
    });
}

export default paginatedSchema;